import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H1, Text1 } from '../../common/common-text';
import BTBox from '../../common/components/BTBox';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

type VisionSection2Props = {
  isInView: boolean;
};

const VisionSection2 = ({ isInView }: VisionSection2Props) => {
  const { t } = useTranslation();
  const [imageAnimated, setImageAnimated] = useState(false);
  const { isMobile } = useDeviceType();
  const { horizontal: padding } = useResponsivePadding();

  useEffect(() => {
    if (isInView && !imageAnimated) {
      setImageAnimated(true);
    }
  }, [isInView, imageAnimated]);

  return (
    <VerticalLayout paddingLeft={padding} paddingRight={padding} style={{ background: 'white', height: '1004', alignItems: 'center', textAlign: 'center' }}>
      <BTBox height={isMobile ? 40 : `${pxToRem(240)}`} />
      <div style={{ overflow: 'hidden', paddingBottom: '0.5rem' }}>
        <motion.div
          initial={{ y: 100, opacity: 1 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 0.6 : 0.0, ease: 'easeOut' }} // 사라질땐 딜레이 없이 바로 적용되도록함, 딜레이 있음 스크롤 왔다갔다 빨리하면 사라져 있질 않음
        >
          <H1>{t('Making the world brighter')}</H1>
        </motion.div>
      </div>
      <div style={{ overflow: 'hidden', paddingBottom: '0.5rem' }}>
        <motion.div
          initial={{ y: 100, opacity: 1 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 0.6 : 0.0, ease: 'easeOut' }} // 사라질땐 딜레이 없이 바로 적용되도록함, 딜레이 있음 스크롤 왔다갔다 빨리하면 사라져 있질 않음
        >
          <H1>{t('with Technology')}</H1>
        </motion.div>
      </div>
      <BTBox height={isMobile ? 13 : 50} />
      <div style={{ overflow: 'hidden' }}>
        <motion.div
          initial={{ y: 50, opacity: 1 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 1.2 : 0.0, ease: 'easeOut' }} // 사라질땐 딜레이 없이 바로 적용되도록함, 딜레이 있음 스크롤 왔다갔다 빨리하면 사라져 있질 않음
        >
          <Text1 style={{ opacity: '0.6' }}><Trans i18nKey='기술의 힘을 활용하여 삶의 모든 면을 밝고 긍정적인 방향으로' /></Text1>
        </motion.div>
      </div>
      <div style={{ overflow: 'hidden' }}>
        <motion.div
          initial={{ y: 50, opacity: 1 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 1.2 : 0.0, ease: 'easeOut' }} // 사라질땐 딜레이 없이 바로 적용되도록함, 딜레이 있음 스크롤 왔다갔다 빨리하면 사라져 있질 않음
        >
          <Text1 style={{ opacity: '0.6' }}>{t('이끄는 것이 우리의 미션입니다.')}</Text1>
        </motion.div>
      </div>
      <BTBox height={`${pxToRem(30)}`} />
      <div style={{ overflow: 'hidden' }}>
        <motion.div
          initial={{ y: 50, opacity: 1 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 1.2 : 0.0, ease: 'easeOut' }} // 사라질땐 딜레이 없이 바로 적용되도록함, 딜레이 있음 스크롤 왔다갔다 빨리하면 사라져 있질 않음
        >
          <Text1 style={{ opacity: '0.6' }}>{t('이는 혁신적인 SMART FLOW뿐 만 아니라,')}</Text1>
        </motion.div>
      </div>
      <div style={{ overflow: 'hidden' }}>
        <motion.div
          initial={{ y: 50, opacity: 1 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 1.2 : 0.0, ease: 'easeOut' }} // 사라질땐 딜레이 없이 바로 적용되도록함, 딜레이 있음 스크롤 왔다갔다 빨리하면 사라져 있질 않음
        >
          <Text1 style={{ opacity: '0.6' }}><Trans i18nKey='모든 기술 분야에서 지속 가능성과 효율성을 추구함으로써 실현됩니다.'/></Text1>
        </motion.div>
      </div>
      <BTBox height={`${pxToRem(30)}`} />
      <div style={{ overflow: 'hidden' }}>
        <motion.div
          initial={{ y: 50, opacity: 1 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 1.2 : 0.0, ease: 'easeOut' }} // 사라질땐 딜레이 없이 바로 적용되도록함, 딜레이 있음 스크롤 왔다갔다 빨리하면 사라져 있질 않음
        >
          <Text1 style={{ opacity: '0.6' }}>{t('우리는 기술이 인간의 삶을 개선하고')}</Text1>
        </motion.div>
      </div>
      <div style={{ overflow: 'hidden' }}>
        <motion.div
          initial={{ y: 50, opacity: 1 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: isInView ? 1.2 : 0.0, ease: 'easeOut' }} // 사라질땐 딜레이 없이 바로 적용되도록함, 딜레이 있음 스크롤 왔다갔다 빨리하면 사라져 있질 않음
        >
          <Text1 style={{ opacity: '0.6' }}>{t('환경적 책임을 강화하는데 필수적임을 믿습니다.')}</Text1>
        </motion.div>
      </div>
      <BTBox height={isMobile ? 72 : `${pxToRem(240)}`} />
    </VerticalLayout>
  );
};

export default VisionSection2;
